function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { keyToString } from './item-key';
import ParentedItemKey from './parented-item-key';
/**
 *
 * @param item - The original item to be cloned (will not be altered)
 * @param overwrite - Any subset of `item` properties that should be altered during clone
 * @returns A deep copy of `item`, optionally with some parameters replaced by `overwrite`
 */
export function clone(item, overwrite) {
  // Deep clone to avoid modification of original item
  var cloned = JSON.parse(JSON.stringify(item));
  Object.keys(overwrite !== null && overwrite !== void 0 ? overwrite : {}).forEach(function (key) {
    cloned[key] = overwrite[key];
  });
  return cloned;
}
var Item = /*#__PURE__*/function (_ParentedItemKey) {
  // The rationale for the difference between an args object and standalone parameters
  // is that the args is pure data from the backend,
  // while parameters are metadata that's only needed for constructing the items
  function Item(args, type, isContainer) {
    var _this;
    _classCallCheck(this, Item);
    _this = _callSuper(this, Item, [args.id, type, args.parent]);
    _this.name = void 0;
    _this.isContainer = void 0;
    _this.history = void 0;
    _this.permissions = void 0;
    _this.isShared = void 0;
    _this.customFields = void 0;
    _this.lock = void 0;
    _this.legacyItem = void 0;
    _this.isReadByClientUser = void 0;
    _this.customItemMetaData = void 0;
    _this.name = args.name;
    _this.isContainer = isContainer;
    _this.history = args.history;
    _this.permissions = args.permissions;
    _this.isShared = args.isShared;
    _this.customFields = args.customFields || new Map();
    _this.lock = args.lock;
    _this.legacyItem = args.legacyItem || null;
    _this.isReadByClientUser = args.isReadByClientUser;
    _this.customItemMetaData = args.customItemMetaData;
    return _this;
  }

  /**
   * @returns `item.type|item.id("item.name")`
   * Example:
   * `FOLDER|fakeId1234567("Filename.pdf")`
   */
  _inherits(Item, _ParentedItemKey);
  return _createClass(Item, [{
    key: "toString",
    value: function toString() {
      return "".concat(keyToString(this), "(\"").concat(this.name, "\")");
    }
  }]);
}(ParentedItemKey);
export { Item as default };
